import * as anchor from '@project-serum/anchor';

import './Store.css';
import Products from './Products';

export interface StoreProps {
  connection: anchor.web3.Connection;
  txTimeout: number;
  rpcHost: string;
}

export const PLACEHOLDER = '2nVnbiuzVa9sAK1GDzuhB6WV4ibdoUdWzuXAWFyj9fgm'

const gooneyOriginals = [
  "BVfgbcSuMhq25EUzsbREnYMLEFjJZ9C3Vaz1c9qSurLG",
  "RLKA9psXmy8Do83JGpNiKKwNaT5fJGhLcwRDMhJaypB",
  "DbL7yt3C2WGZBqv2u7ecmXxcaF161Gx1TPWXf2GgZKV5",
];

const gooneyCollabs = [
  "2a5fZCVA568Szk58H235CCcbyZAP2v4vbWu72tvQWhn6",
  "AsqjR8MV7VaZsBcVB58cK8MdFsoMvqWgz1m3VZ3csMvY",
  "3XsQTuSC5eupBQfEQPUdnGSg2Krzi8kT2EWJdmwWPvaq",
];

const imageMap: {
  [key: string]: { img: string; name: string; artist: string | undefined };
} = {
  BVfgbcSuMhq25EUzsbREnYMLEFjJZ9C3Vaz1c9qSurLG: {
    img: "/images/OPM.gif",
    name: "ONE PUNCH GOON",
    artist: undefined,
  },
  RLKA9psXmy8Do83JGpNiKKwNaT5fJGhLcwRDMhJaypB: {
    img: "/images/rated_n.png",
    name: "RATED N",
    artist: undefined,
  },
  DbL7yt3C2WGZBqv2u7ecmXxcaF161Gx1TPWXf2GgZKV5: {
    img: "/images/MikeTyson.png",
    name: "MIKE GOONEY",
    artist: undefined,
  },
  "2a5fZCVA568Szk58H235CCcbyZAP2v4vbWu72tvQWhn6": {
    img: "/images/outkast.png",
    name: "OUTKAST GOON",
    artist: "OutkastNFTs",
  },
  AsqjR8MV7VaZsBcVB58cK8MdFsoMvqWgz1m3VZ3csMvY: {
    img: "/images/tej.png",
    name: "TEJ X GOONEYS",
    artist: "Tejji90",
  },
  "3XsQTuSC5eupBQfEQPUdnGSg2Krzi8kT2EWJdmwWPvaq": {
    img: "/images/NewGoon.png",
    name: "NEW GOON OTB",
    artist: "Jimmycoolice",
  },
  PLACEHOLDER: {
    img: "/images/coming_soon.jpg",
    name: "none",
    artist: undefined,
  },
};

export const getMetadata = (candyMachineId: string) => {
  if (candyMachineId in imageMap) {
    return imageMap[candyMachineId];
  }

  return {
    img: '/images/coming_soon.jpg',
    name: 'none',
    artist: undefined,
  };
}

const Store = (props: StoreProps) => {
  return (
    <div style={{width: '80%', margin: 'auto'}}>
      <div className='headerContainer' >
        <img
            style={{ width: 400, textAlign:'center', margin: 'auto', display: 'block' }}
            src="/images/nastystore_logo.png"
            alt="Gooney Toons Logo"/>
      </div>
      <div className='gooneyOriginContainer' >
        <h1 style={{textAlign: 'left'}}>GOONEY ORIGINALS</h1>
        <Products 
          candyMachineIds={gooneyOriginals}
          connection={props.connection}
          txTimeout={props.txTimeout}
          rpcHost={props.rpcHost}
        />
      </div>
      <div className='collabContainer' >
        <h1 style={{textAlign: 'left'}}>GOONEY COLLABS</h1>
        <Products 
          candyMachineIds={gooneyCollabs}
          connection={props.connection}
          txTimeout={props.txTimeout}
          rpcHost={props.rpcHost}
        />
      </div>
    </div>
  )
};

export default Store;
